"use client";

import { FunctionComponent, useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
// import { Button } from "primereact/button";
// import { FileUpload } from "primereact/fileupload";
import { handlingUrlParams } from "Utils/AppUtils";
import AdminServices from "services/admin-services";
import Loader from "common/Loader";
import { setToaster } from "common/toastStore";
import { Sidebar } from "primereact/sidebar";
// import { confirmDialog } from "primereact/confirmdialog";

interface DocTableDataProps {
  customerId: number;
  jobId: number;
  statusID: number;
}

const DocTable: FunctionComponent<DocTableDataProps> = ({
  customerId,
  // statusID,
  jobId,
}) => {
  const [data, setData] = useState<any[]>([]);
  const [showLoanModel, setShowLoanModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
  });

  useEffect(() => {
    loadLazyData();
  }, [lazyParams]);

  const loadLazyData = () => {
    setLoading(true);
    AdminServices.getDocLoans(
      handlingUrlParams({
        JobId: jobId,
        PageNumber: lazyParams.page,
        PageSize: lazyParams.rows,
      })
    )
      .then((response: any) => {
        const parsedHeaders = JSON.parse(response.headers["x-pagination"]);
        setData(response.data);
        setTotalRecords(parsedHeaders.TotalCount);
        setLoading(false);
      })
      .catch((e: Error) => {
        console.error(e);
        setLoading(false);
      });
  };

  // ✅ Upload file handler
  // const handleUpload = async (event: any) => {
  //   const file = event.files[0];
  //   if (!file) return;

  //   const formData = new FormData();
  //   formData.append("File", file);

  //   setLoading(true);
  //   try {
  //     await AdminServices.uploadDoc(
  //       jobId,
  //       handlingUrlParams({ customerId }),
  //       formData
  //     );

  //     setToaster({
  //       severity: "success",
  //       summary: "Success",
  //       detail: `File uploaded successfully for Document Types`,
  //     });
  //   } catch (error: any) {
  //     setToaster({
  //       severity: "error",
  //       summary: "Upload Failed",
  //       detail: error?.message || "Something went wrong while uploading file",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // ✅ Delete handler
  // const handleDeleteRow = (rowData: { id: any; jobId: number }) => {
  //   confirmDialog({
  //     message: "Are you sure you want to delete this document?",
  //     header: "Confirmation",
  //     icon: "pi pi-exclamation-triangle",
  //     acceptLabel: "Yes",
  //     rejectLabel: "No",
  //     accept: async () => {
  //       const updatedData = data.filter(
  //         (item: { id: any }) => item.id !== rowData.id
  //       );

  //       setLoading(true);
  //       try {
  //         await AdminServices.updateDoc(
  //           rowData?.jobId,
  //           handlingUrlParams({ customerId }),
  //           updatedData
  //         );
  //         setData(updatedData);
  //         setToaster({
  //           severity: "success",
  //           summary: "Success",
  //           detail: `Deleted document successfully!`,
  //         });
  //       } catch (e: any) {
  //         setToaster({
  //           severity: "error",
  //           summary: "Error Message",
  //           detail: `${e}`,
  //         });
  //       } finally {
  //         setLoading(false);
  //       }
  //     },
  //     reject: () => {
  //       // Do nothing if rejected
  //     },
  //   });
  // };

  // ✅ Add Document
  // const handleAddDocument = async (newDoc: {
  //   documentType: string;
  //   processOrder: number;
  // }) => {
  //   const newEntry = {
  //     id: Math.max(...data.map((d: { id: any }) => d.id), 0) + 1,
  //     jobId: data[0]?.jobId || jobId,
  //     documentType: newDoc.documentType,
  //     processOrder: newDoc.processOrder,
  //   };

  //   const updatedData = [...data, newEntry];

  //   setLoading(true);
  //   try {
  //     setData(updatedData);

  //     await AdminServices.updateDoc(
  //       newEntry.jobId,
  //       handlingUrlParams({ customerId }),
  //       updatedData
  //     );

  //     setToaster({
  //       severity: "success",
  //       summary: "Success",
  //       detail: "New document added successfully!",
  //     });
  //     setShowLoanModel(false);
  //   } catch (error: any) {
  //     setToaster({
  //       severity: "error",
  //       summary: "Add Document Failed",
  //       detail: error?.message || "Something went wrong while adding document",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // ✅ Pagination event
  const onPage = (event: any) => {
    setLazyParams({
      ...lazyParams,
      first: event.first,
      rows: event.rows,
      page: event.page + 1,
    });
  };

  // ✅ Reorder handler (pagination-safe)
  const handleReorder = async (e: any) => {
    const reorderedPage = e.value;

    const start = lazyParams.first;
    const end = lazyParams.first + lazyParams.rows;

    const before = data.slice(0, start);
    const after = data.slice(end);
    const merged = [...before, ...reorderedPage, ...after];

    // Update processOrder sequentially (optional)
    const updated = merged.map((item) => ({
      ...item,
    }));

    setData(updated);
    console.log("✅ Full reordered dataset:", updated);

    try {
      await AdminServices.updateDoc(
        jobId,
        handlingUrlParams({ customerId }),
        updated
      );
      setToaster({
        severity: "success",
        summary: "Success",
        detail: "Reordered successfully!",
      });
    } catch (error: any) {
      setToaster({
        severity: "error",
        summary: "Reorder Failed",
        detail: error?.message || "Failed to save new order",
      });
    }
  };

  // ✅ Row actions
  // const actionTemplate = (rowData: any) => (
  //   <div className="flex gap-2">
  //     <Button
  //       icon="pi pi-trash"
  //       style={{
  //         background: "red",
  //         border: "1px solid red",
  //         padding: "5px 10px",
  //         width: "auto",
  //       }}
  //       onClick={() => handleDeleteRow(rowData)}
  //       // disabled={statusID === 18}
  //     />
  //   </div>
  // );

  return (
    <div className="card">
      <div className="flex justify-between items-center py-3">
        <h3 className="text-lg font-semibold mb-3">Document Types</h3>
        {/* <div className="flex items-center">
          <FileUpload
            mode="basic"
            name="file"
            auto
            customUpload
            chooseLabel="Upload"
            uploadHandler={handleUpload}
            className="p-button-sm p-button-outlined p-button-success mx-4"
            // disabled={statusID === 18}
          />
          <Button
            onClick={() => setShowLoanModel(true)}
            label="Add Document"
            className="p-button-success p-button-outlined"
            style={{ padding: "5px 15px", fontSize: 12 }}
          />
        </div> */}
      </div>

      <DataTable
        value={data}
        reorderableRows
        onRowReorder={handleReorder}
        loading={loading}
        lazy
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        totalRecords={totalRecords}
        rows={lazyParams.rows}
        first={lazyParams.first}
        onPage={onPage}
        rowsPerPageOptions={[10, 20, 50]}
        stripedRows
        responsiveLayout="scroll"
        emptyMessage="No Document Types found"
      >
        {/* <Column rowReorder style={{ width: "3rem" }} />

        <Column field="id" header="ID" style={{ width: "10%" }} />
        <Column field="jobId" header="Job ID" style={{ width: "20%" }} /> */}
        <Column
          field="documentType"
          header="Document Type"
          style={{ width: "40%" }}
        />
        <Column
          field="processOrder"
          header="Process Order"
          style={{ width: "40%" }}
        />
        {/* <Column
          header="Actions"
          body={actionTemplate}
          style={{ width: "20%" }}
        /> */}
      </DataTable>

      {loading && <Loader />}

      <Sidebar
        visible={showLoanModel}
        position="right"
        style={{ minHeight: 500, width: 400 }}
        onHide={() => setShowLoanModel(false)}
      >
        {/* <AddDocument
          onClose={() => setShowLoanModel(false)}
          handleAddDcoument={handleAddDocument}
        /> */}
      </Sidebar>
    </div>
  );
};

export default DocTable;
